import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Installation`}</h1>
    <h2>{`CocoaPods`}</h2>
    <p>{`Tesfy is available through `}<a parentName="p" {...{
        "href": "https://cocoapods.org"
      }}>{`CocoaPods`}</a>{`. To install it, simply add the following line to your Podfile:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`pod 'Tesfy'
`}</code></pre>
    <h2>{`Initialization`}</h2>
    <p>{`Once imported, instantiate the engine with a `}<inlineCode parentName="p">{`datafile`}</inlineCode>{` and optionally a `}<inlineCode parentName="p">{`storage`}</inlineCode>{` layer to enable sticky bucketing, a `}<inlineCode parentName="p">{`userId`}</inlineCode>{` and a set of `}<inlineCode parentName="p">{`attributes`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`import Tesfy

let tesfy = Tesfy(datafile: datafile, storage: storage, userId: userId, attributes: attributes)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      